import { useEffect, useState, useRef } from 'react';
import { getQueryParams, getResourceURLFromLocation, handleResourceUrl, NATIVE_MOCK } from '../../utils/index';
import Krpano from './components/krpano';
import './index.less';
import { KrpanoEventName } from './types/event';
import { getPanoramaModuleConfig } from './api/config';
import PanoRoaming from './components/pano-roaming/pano-roaming';
import PanoramaMockData from './api/mock';
import { loadScene, setAutoRotate } from './api/panorama';
import { getPanoramaPreviewParams } from './utils';

export function Panorama() {
  const [config, setConfig] = useState<any>(null);
  const [krpanoCurScene, setKrpanoCurScene] = useState<string>('');
  const [krpanoCurRotate, setKrpanoCurRotate] = useState<number>(0);
  const [kpReady, setKpReady] = useState<boolean>(false);

  const defaultHouseTypeId = useRef<string>('');
  const isHideOtherContent = useRef<boolean>(false);

  useEffect(() => {
    initResourceBaseURL();
    initConfig();
    addListeners();
    initConfigByUrl();

    return () => {
      removeListeners();
    };
  }, []);

  useEffect(() => {
    if (krpanoCurScene) {
      loadScene(krpanoCurScene);
    }
  }, [krpanoCurScene]);

  const initConfig = async () => {
    const data = (await getPanoramaModuleConfig()) as any;
    await setConfig(data);
  };

  const initTitle = (title: string): void => {
    document.title = title || '全景';
  };

  const initConfigByUrl = () => {
    const querys = getQueryParams();
    const { houseTypeId, hideOtherContent } = querys;
    if (houseTypeId) {
      defaultHouseTypeId.current = houseTypeId;
    }
    isHideOtherContent.current = hideOtherContent === 'true';
  };

  const initResourceBaseURL = () => {
    let resourceURL = '';
    const preview = getPanoramaPreviewParams();
    if (preview) {
      resourceURL = preview.base;
    } else if (NATIVE_MOCK) {
      resourceURL = PanoramaMockData.resourceURL;
    } else {
      resourceURL = getResourceURLFromLocation();
    }
    handleResourceUrl.setParams({
      resource: resourceURL,
    });
  };

  const handleViewChange = (e) => {
    // console.log(e.detail.hlookat);
    if (e.detail?.hlookat && e.detail.hlookat !== krpanoCurRotate) {
      setKrpanoCurRotate(Number(e.detail.hlookat));
    }
  };

  const handleHotClick = (e) => {
    console.log(e.detail.scene);
    const scene = e.detail.scene;
    if (scene && scene !== krpanoCurScene) {
      setKrpanoCurScene(scene);
    }
  };

  const handleKrpanoReady = () => {
    console.log('krpano ready');
    setKpReady(true);
  };

  const handleSceneProgress = (e) => {
    if (e.detail.params.progress === '100') {
      console.log('Scene Progress 100%');
      setAutoRotate(true);
    }
  };

  const addListeners = () => {
    window.addEventListener(KrpanoEventName.Ready, handleKrpanoReady);
    window.addEventListener(KrpanoEventName.ViewChange, handleViewChange);
    window.addEventListener(KrpanoEventName.HotSpotClick, handleHotClick);
    window.addEventListener(KrpanoEventName.SceneProgress, handleSceneProgress);
  };

  const removeListeners = () => {
    window.removeEventListener(KrpanoEventName.Ready, handleKrpanoReady);
    window.removeEventListener(KrpanoEventName.ViewChange, handleViewChange);
    window.removeEventListener(KrpanoEventName.HotSpotClick, handleHotClick);
    window.addEventListener(KrpanoEventName.SceneProgress, handleSceneProgress);
  };

  useEffect(() => {
    if (config) {
      initTitle(config.project?.name);
    }
  }, [config]);

  return config ? (
    <div className='xsdj-pano'>
      <Krpano />
      {kpReady && (
        <PanoRoaming
          moduleConfig={config}
          krpanoCurScene={krpanoCurScene}
          setKrpanoCurScene={setKrpanoCurScene}
          krpanoCurRotate={krpanoCurRotate}
          defaultHouseTypeId={defaultHouseTypeId.current}
          hideOtherContent={isHideOtherContent.current}
        />
      )}
    </div>
  ) : null;
}
